
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire716c"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire716c"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

var $27076ce67bdfadcd$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse('["9vqfN","index.e4a5c045.js","8AvM3","LOGO-BLACK.1aea6cba.svg","k9Ndc","nmc_render_black_green.b569a512.png","ezsEm","clock.08566392.png","166as","magnify.02d3b6a8.png","2Hk08","graph.5ba2ed30.png","6GbUH","pound.e1b145dd.png","j7B35","platform.dc91d3f2.png","lEteI","micro-explore.ad48314a.ad48314a.mp4","8iDyL","Isaac - Shoreditch.50c5acb1.jpeg","fc8s0","Steve - Shoreditch.c90fc36f.jpeg","6Gvnd","Sam - Shoreditch.7ef3942b.jpeg","fA7SA","Chris - Shoreditch.86183210.jpeg","dTo0a","Elena - Shoreditch.bf11e4ea.jpg","40YSX","POLARON-press-shot-landscape.3a9a51a1.png","HFgXV","Ronan - Shoreditch.409a6e57.jpg","2DLNu","slicegan.0a1fc999.png","24QZr","fusion.80dd9178.png","2Dozk","kintsugi.f65fbaa4.png","1bJwb","characterisation.84f1ba28.png","28Mcs","faraday-logo.f1ec653b.png","aIxl3","Imperial-logo.c5b4a703.svg","kQtnK","vcc-logo.34e53c06.png","dO3A0","wmg-2016.d92fa973.png","6gi9C","manchester-prize.d2c43342.png","1ihq8","team1.fa1fdeff.jpg","h6317","team2.dc8bee0e.jpg","86Fni","chris_steve_office.96355eab.jpg","5h9CN","index.87059c7f.css"]'));


//# sourceMappingURL=index.runtime.76f2b0f5.js.map
